import Vue from "vue";
import VueI18n from "vue-i18n";
import { languageOptions, getMessagesAndLanguages } from "../src/util/i18n";
import elementLocale from 'element-ui/lib/locale'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhTwLocale from 'element-ui/lib/locale/lang/zh-TW'

Vue.use(VueI18n);

const [messages] = getMessagesAndLanguages();

export const i18n = new VueI18n({
  locale: `${navigator.language}`.toLowerCase() || languageOptions[0].key,
  fallbackLocale: languageOptions[1].key,
  silentTranslationWarn: true,
  messages: {
    "zh-tw": { ...messages["zh-tw"], ...elementZhTwLocale },
    "en": { ...messages["en"], ...elementEnLocale }
  }
});

elementLocale.i18n((key, value) => i18n.t(key, value))